var _path, _ellipse, _path2, _ellipse2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 420,
    viewBox: "0 0 420 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M344 243.511C344 329.438 344 371.452 264.236 371.808C263.684 371.811 263.209 371.363 263.209 370.811V324.91C263.209 324.358 263.662 323.91 264.214 323.904C308.931 323.397 343.4 289.075 344 243.511Z",
    fill: "url(#paint0_linear_89_2038)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.5,
    cy: 244.234,
    rx: 81.5,
    ry: 83.234,
    transform: "rotate(-180 262.5 244.234)",
    fill: "url(#paint1_linear_89_2038)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77 176.3C77 90.3727 77 48.3584 156.764 48.0022C157.316 47.9998 157.791 48.4477 157.791 49V94.9007C157.791 95.4529 157.338 95.9001 156.786 95.9064C112.069 96.4136 77.5997 130.736 77 176.3Z",
    fill: "url(#paint2_linear_89_2038)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.5,
    cy: 175.576,
    rx: 81.5,
    ry: 83.234,
    fill: "url(#paint3_linear_89_2038)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_2038",
    x1: 263.209,
    y1: 371.811,
    x2: 378.912,
    y2: 298.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B69D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07346F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_89_2038",
    x1: 344,
    y1: 161,
    x2: 177.569,
    y2: 323.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B69D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07346F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_89_2038",
    x1: 101.132,
    y1: 44.573,
    x2: 129.182,
    y2: 131.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5390E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1357B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_89_2038",
    x1: 228.357,
    y1: 107.476,
    x2: 88.9213,
    y2: 245.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5390E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1357B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.205c4aef3bcf4cef6096a672282d4eac.svg";
export { ForwardRef as ReactComponent };